module.exports = __webpack_public_path__ + "static/blog-05-79c6d47eba9d32b536da32835c8625e1.jpg";